// extracted by mini-css-extract-plugin
module.exports = {"LoadingSection":"styles_LoadingSection__UXAdf","spinner":"styles_spinner__Ft6GQ"};